<script lang="ts" setup>
/**
 * コミュニティトーク用のラベル表示。
 * UIを統一するため、labelタグを使用する場合はこちらのコンポーネントを使用してください。
 */

// NOTE: ここのみ他コンポーネントとPropsの定義方法が違う理由
// Propsのデフォルト値を設定するにはinterface形式ではできず、下記の形式の記述でないと出来ないため。
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps({
	/**
	 * labelタグのname属性。
	 */
	name: {
		type: String,
		required: false,
	},
	/**
	 * ラベル内容。
	 */
	text: {
		type: String,
		required: true,
	},
	/**
	 * 無効化状態かどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
});
</script>

<template>
	<label :name="name" :class="disabled ? 'revico-community-talk-label revico-community-talk-disabled' : 'revico-community-talk-label'">{{ text }}</label>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-label {
		display: block;
		margin-bottom: 4px;
		font-size: 0.8em;
	}
	&-disabled {
		opacity: var(--disabled-input-opacity);
	}
}
</style>
